import { Button, Col, Form, Modal, Row, Select, message } from "antd";
import { useContext, useEffect } from "react";
import Moment from "react-moment";
import { AuthContext } from "../../../../context/AuthContext";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleFetchUsers } from "../../../../api/users";
import { handleAssignInquiry } from "../../../../api/inquiries";
const { Option } = Select;

export default function AssignModal({ isVisible, setVisible, inquiry }: any) {
  const { auth } = useContext(AuthContext);
  const [form] = Form.useForm();
  const queryClient = useQueryClient();

  const { data: users } = useQuery({
    queryKey: ["users"],
    queryFn: handleFetchUsers,
  });

  const userOptions = users?.map((user: any, index: number) => (
    <Option value={user?._id} key={index}>
      {user?.name}
    </Option>
  ));

  const { mutate, isLoading } = useMutation({
    mutationFn: handleAssignInquiry,
    onSuccess: () => {
      message.success("Assigned Successfully");
      form.resetFields();
      queryClient.invalidateQueries({
        queryKey: ["newInquiries"],
      });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { consultant } = await form.validateFields();
    const data = { user: consultant };

    await mutate({ inquiry_id: inquiry?._id, data });
  };

  useEffect(() => {
    form.setFieldsValue({ consultant: auth?._id });
  }, [form]);

  if (!inquiry) {
    return <></>;
  }

  return (
    <Modal
      open={isVisible}
      title="ASSIGN CONSULTANT"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" danger onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="assignConsultant"
          danger
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
        >
          Assign
        </Button>,
      ]}
    >
      <div className="">
        <span className="text-2xl">{inquiry?.name}, </span>
        <span>
          Created <Moment format="DD/MM/YYYY">{inquiry?.createdAt}</Moment>
        </span>
      </div>
      <div className="mt-4">ASSIGN TO:-</div>
      <Form
        id="assignConsultant"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="consultant"
              rules={[
                {
                  required: true,
                  message: "Please select user",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search and select user"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {userOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
